import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import ClipboardJS from 'clipboard';

import type { Service } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';

interface Args {
	text: string;
	onAfterCopy?: () => void;
}

export default class ClipboardCopyComponent extends Component<Args> {
	@service('logger') declare loggerService: Service.Logger;

	@action
	setupView(node: HTMLElement) {
		const that = this;

		const clipboard = new ClipboardJS(node, {
			text: function () {
				return that.args.text;
			},
		});

		clipboard.on('success', function () {
			if (typeof that.args.onAfterCopy === 'function') {
				that.args.onAfterCopy();
			}
		});

		clipboard.on('error', function (e) {
			that.loggerService.logError('ClipboardCopy error', {
				action: e.action,
				trigger: e.trigger,
			});
		});
	}

	<template>
		<div class="clipboardCopy" {{didInsert this.setupView}}></div>
	</template>
}
